import type { FaireProductEntity } from "../../entity_types/product";

export const p_eg25fg7pbz: FaireProductEntity = {
  token: "p_eg25fg7pbz",
  type: "product",
  name: "TEAM CHARM NECKLACE-HOGS BLACK AND WHITE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl:
    "https://cdn.faire.com/fastly/77e395e72d0ce5239e98f8af4d63bbce3ec93c99f56c04a4da5fff455fd38231.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.16,
  description:
    "Add a playful touch to your look with the Team Charm Necklace – Hogs Black and White! Whether worn alone or as a scarf charm, this fun accessory keeps your team spirit front and center with bold style.\n",
  tags: [],
  msrpDollars: 26.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:30.574Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
